/* =========================================================
   OVERTOP / Urban-Haul — ATC Celebration (Horizon port)
   Full-screen confetti + party card on add-to-cart.
   Layers on top of Horizon's native <fly-to-cart>.
   Listens for cart:update from <product-form-component> only.
   ========================================================= */

(function () {
  'use strict';

  var VERSION = '1.0.0';
  window.__OT_ATC_CELEBRATION_VERSION = VERSION;

  var ACTIVE_MS = 3900;
  var CLEANUP_MS = 4300;

  var CONFIG = {
    title: 'Added to Cart!',
    subtitle: 'THANKS‼️',
    note: 'Your cart is ready for checkout',
    emoji: '🎉'
  };

  var hideTimer = null;
  var cleanupTimer = null;
  var stylesInjected = false;

  function injectStyles() {
    if (stylesInjected) return;
    stylesInjected = true;

    var css = [
      '#otAtcCelebration{position:fixed;inset:0;z-index:2147483000;pointer-events:none;opacity:0;visibility:hidden;overflow:hidden;display:flex;align-items:center;justify-content:center;background:transparent;transition:opacity .18s ease,visibility .18s ease}',
      '#otAtcCelebration.ot-show{opacity:1;visibility:visible}',
      '#otAtcCelebration .ot-party-card{position:relative;z-index:5;width:min(86vw,390px);padding:22px 18px 20px;border-radius:24px;text-align:center;background:rgba(255,255,255,.94);box-shadow:0 24px 70px rgba(0,0,0,.22),0 0 0 1px rgba(255,255,255,.70) inset;transform:scale(.82);animation:otPartyCardPop 2.6s cubic-bezier(.16,1,.3,1) forwards}',
      '#otAtcCelebration .ot-party-emoji{font-size:76px;line-height:1;margin-bottom:8px;filter:drop-shadow(0 12px 18px rgba(0,0,0,.18));animation:otPartyEmojiBoom 2.2s cubic-bezier(.16,1,.3,1) forwards}',
      '#otAtcCelebration .ot-party-title{font-size:25px;font-weight:1000;letter-spacing:.2px;color:#111;margin:0;text-transform:uppercase}',
      '#otAtcCelebration .ot-party-sub{margin-top:7px;font-size:15px;font-weight:850;color:#e0001a}',
      '#otAtcCelebration .ot-party-note{margin-top:5px;font-size:12px;font-weight:700;color:rgba(0,0,0,.58)}',
      '#otAtcCelebration .ot-confetti-piece{position:absolute;left:50%;top:50%;z-index:3;width:var(--w);height:var(--h);border-radius:3px;background:var(--c);opacity:0;transform:translate(-50%,-50%) rotate(0deg) scale(.7);animation:otConfettiBurst var(--d) cubic-bezier(.11,.72,.22,1) forwards}',
      '#otAtcCelebration .ot-confetti-piece.is-circle{border-radius:999px}',
      '#otAtcCelebration .ot-confetti-piece.is-star{width:auto;height:auto;background:transparent;font-size:var(--s);border-radius:0}',
      '#otAtcCelebration .ot-screen-spark{position:absolute;z-index:2;font-size:var(--s);left:var(--left);top:var(--top);opacity:0;animation:otSparkFloat var(--d) ease-out forwards}',
      '@keyframes otPartyCardPop{0%{transform:scale(.72) translateY(16px);opacity:0}12%{transform:scale(1.08) translateY(0);opacity:1}28%{transform:scale(1) translateY(0);opacity:1}74%{transform:scale(1) translateY(0);opacity:1}100%{transform:scale(.96) translateY(-8px);opacity:0}}',
      '@keyframes otPartyEmojiBoom{0%{transform:scale(.4) rotate(-18deg);opacity:0}18%{transform:scale(1.30) rotate(8deg);opacity:1}40%{transform:scale(1) rotate(-4deg);opacity:1}78%{transform:scale(1) rotate(0deg);opacity:1}100%{transform:scale(.9) rotate(0deg);opacity:0}}',
      '@keyframes otConfettiBurst{0%{opacity:0;transform:translate(-50%,-50%) rotate(0deg) scale(.45)}8%{opacity:1}76%{opacity:1}100%{opacity:0;transform:translate(calc(-50% + var(--x)),calc(-50% + var(--y))) rotate(var(--r)) scale(1)}}',
      '@keyframes otSparkFloat{0%{opacity:0;transform:translateY(12px) scale(.6) rotate(-8deg)}18%{opacity:1}76%{opacity:1}100%{opacity:0;transform:translateY(-95px) scale(1.35) rotate(12deg)}}',
      '@media screen and (max-width:480px){#otAtcCelebration .ot-party-card{width:86vw;padding:20px 14px 18px;border-radius:22px}#otAtcCelebration .ot-party-emoji{font-size:70px}#otAtcCelebration .ot-party-title{font-size:22px}#otAtcCelebration .ot-party-sub{font-size:14px}}',
      '@media (prefers-reduced-motion: reduce){#otAtcCelebration .ot-confetti-piece,#otAtcCelebration .ot-screen-spark{display:none !important}#otAtcCelebration .ot-party-card,#otAtcCelebration .ot-party-emoji{animation-duration:1.4s !important}}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'ot-atc-celebration-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function ensureOverlay() {
    var overlay = document.getElementById('otAtcCelebration');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'otAtcCelebration';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  function buildCardHTML() {
    return [
      '<div class="ot-party-card">',
        '<div class="ot-party-emoji">' + CONFIG.emoji + '</div>',
        '<p class="ot-party-title">' + CONFIG.title + '</p>',
        '<div class="ot-party-sub">' + CONFIG.subtitle + '</div>',
        '<div class="ot-party-note">' + CONFIG.note + '</div>',
      '</div>'
    ].join('');
  }

  function createConfetti(overlay) {
    var colors = ['#e0001a', '#111111', '#ffffff', '#ffd400', '#ff7a00', '#20b26b', '#2f80ed'];
    var emojis = ['🎉', '🎁', '✨', '🔥', '🎊'];
    var isMobile = window.matchMedia('(max-width: 600px)').matches;
    var total = isMobile ? 125 : 160;
    var maxX = Math.max(window.innerWidth * 0.78, 390);
    var maxY = Math.max(window.innerHeight * 0.70, 460);

    for (var i = 0; i < total; i++) {
      var piece = document.createElement('span');
      var useEmoji = Math.random() > 0.86;
      if (useEmoji) {
        piece.className = 'ot-confetti-piece is-star';
        piece.textContent = emojis[Math.floor(Math.random() * emojis.length)];
        piece.style.setProperty('--s', randomBetween(16, 30) + 'px');
      } else {
        piece.className = 'ot-confetti-piece';
        if (Math.random() > 0.72) piece.classList.add('is-circle');
        piece.style.setProperty('--c', colors[Math.floor(Math.random() * colors.length)]);
        piece.style.setProperty('--w', randomBetween(7, 16) + 'px');
        piece.style.setProperty('--h', randomBetween(9, 24) + 'px');
      }
      var angle = randomBetween(0, Math.PI * 2);
      var dx = randomBetween(maxX * 0.25, maxX);
      var dy = randomBetween(maxY * 0.25, maxY);
      piece.style.setProperty('--x', Math.cos(angle) * dx + 'px');
      piece.style.setProperty('--y', Math.sin(angle) * dy + 'px');
      piece.style.setProperty('--r', randomBetween(240, 1280) + 'deg');
      piece.style.setProperty('--d', randomBetween(1800, 3000) + 'ms');
      overlay.appendChild(piece);
    }
  }

  function createScreenSparks(overlay) {
    var sparks = ['✨', '🎊', '💥', '🎁', '🔥'];
    for (var i = 0; i < 18; i++) {
      var spark = document.createElement('span');
      spark.className = 'ot-screen-spark';
      spark.textContent = sparks[Math.floor(Math.random() * sparks.length)];
      spark.style.setProperty('--left', randomBetween(8, 92) + 'vw');
      spark.style.setProperty('--top', randomBetween(12, 88) + 'vh');
      spark.style.setProperty('--s', randomBetween(18, 34) + 'px');
      spark.style.setProperty('--d', randomBetween(1700, 2800) + 'ms');
      overlay.appendChild(spark);
    }
  }

  function fireCelebration() {
    injectStyles();
    var overlay = ensureOverlay();
    clearTimeout(hideTimer);
    clearTimeout(cleanupTimer);
    overlay.classList.remove('ot-show');
    overlay.innerHTML = buildCardHTML();
    createConfetti(overlay);
    createScreenSparks(overlay);
    requestAnimationFrame(function () { overlay.classList.add('ot-show'); });
    hideTimer = setTimeout(function () { overlay.classList.remove('ot-show'); }, ACTIVE_MS);
    cleanupTimer = setTimeout(function () { overlay.innerHTML = ''; }, CLEANUP_MS);
  }

  var lastFiredAt = 0;
  var DEBOUNCE_MS = 1500;

  function maybeFire(reason) {
    var now = Date.now();
    if (now - lastFiredAt < DEBOUNCE_MS) return;
    lastFiredAt = now;
    try { console.log('[ot/celebration] firing', reason); } catch (e) {}
    fireCelebration();
  }

  function isAddSignal(e) {
    var d = e && e.detail;
    if (!d) return false;
    var data = d.data || {};
    if (data.didError) return false;
    var src = data.source || d.sourceId || '';
    if (/^ot-/.test(src)) return false;
    if (src === 'product-form-component') return true;
    if (data.productId || data.variantId) return true;
    return false;
  }

  document.addEventListener('cart:update', function (e) {
    if (isAddSignal(e)) maybeFire('cart:update');
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(
      'add-to-cart-component button, ' +
      'product-form-component button[type="submit"], ' +
      'button[name="add"], ' +
      'sticky-add-to-cart button, ' +
      '[data-add-to-cart]'
    );
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (btn.closest('.quick-add, quick-add-component')) return;
    setTimeout(function () { maybeFire('atc-click'); }, 350);
  }, true);

  window.__OT_CELEBRATION_TEST = fireCelebration;
})();
